import React, {useContext} from "react";
import {useLocalization} from "@progress/kendo-react-intl";

//components
import UserContext from "../../common/UserContext";
import {NoWrapCell} from "../../common/Grid";

//multilingual
import {
    confirmationCodeKey,
    descriptionKey,
    licenseIdKey,
    mainMessages,
    productKey,
    qtyKey,
    returnLicenseKey,
    activationCodeKey,
} from "../../../assets/text/MultilingualText";

//kendo
import {PanelBar, PanelBarItem} from "@progress/kendo-react-layout";
import {Grid, GridColumn} from "@progress/kendo-react-grid";
import {orderBy} from "@progress/kendo-data-query";
import {Button} from "@progress/kendo-react-buttons";
import {
    AssignedPanelbarTitle
} from "../../common/RequestLicense/AssignedPanelbarTitle";


export default function ReviewBanked(props) {
    const {
        siteLanguageDefault
    } = useContext(UserContext);
    const localization = useLocalization();

    const {
        assigned,
        setReview,
    } = props

    const showActivationCodeColumn = assigned.some(host => host.products.some(item => !!item.activation_code));

    return (
        <>
            <PanelBar className={'ksm-panelbar-default'}>
                {assigned.map((item) => {
                    return (
                        <PanelBarItem
                            title={
                                <AssignedPanelbarTitle text={item.panelBarTitle} />
                            }
                            key={item.transaction_id}
                            expanded={true}
                        >
                            <Grid
                                className={'review-banked-gird'}
                                scrollable={'none'}
                                data={orderBy(item.products, [
                                    {
                                        field: "license_id",
                                        dir: "asc",
                                    },
                                ])}
                            >
                                <GridColumn
                                    field="license_id"
                                    title={localization.toLanguageString(licenseIdKey, mainMessages[siteLanguageDefault][licenseIdKey])}
                                    cell={NoWrapCell}
                                />
                                <GridColumn
                                    field="confirmation_code"
                                    title={localization.toLanguageString(confirmationCodeKey, mainMessages[siteLanguageDefault][confirmationCodeKey])}
                                    cell={NoWrapCell}
                                />
                                <GridColumn
                                    field="prod_num"
                                    title={localization.toLanguageString(productKey, mainMessages[siteLanguageDefault][productKey])}
                                    cell={NoWrapCell}
                                />
                                <GridColumn
                                    field="prod_desc"
                                    title={localization.toLanguageString(descriptionKey, mainMessages[siteLanguageDefault][descriptionKey])}
                                />
                                <GridColumn
                                    field="qty_redeemed"
                                    title={localization.toLanguageString(qtyKey, mainMessages[siteLanguageDefault][qtyKey])}
                                />
                                {showActivationCodeColumn && <GridColumn
                                    field="activation_code"
                                    title={localization.toLanguageString(activationCodeKey, mainMessages[siteLanguageDefault][activationCodeKey])}
                                />}
                            </Grid>
                        </PanelBarItem>
                    )
                })}
            </PanelBar>

            <div style={{
                display: 'flex',
                gap: '0.938rem',
                justifyContent: 'end',
            }}>
                <Button
                    themeColor={"primary"}
                    size={"large"}
                    fillMode={"solid"}
                    type={"button"}
                    rounded={"small"}
                    onClick={() => {
                        setReview(false)
                    }}
                >
                    {localization.toLanguageString(returnLicenseKey, mainMessages[siteLanguageDefault][returnLicenseKey])}
                </Button>
            </div>

        </>
    )
}